<template>
  <div class="insurance-tests-wrap my-5">
    <div v-if="loadingState">
      <McSpinner large />
    </div>
    <div v-else>
      <h3 class="text-center">{{ $t('headings.trackers') }}</h3>
      <McTable class="insured-trackers-table" ref="insuredTrackersTable" sortBy="status" :sortDesc="true" primaryKey="imei" :fields="fields" :items="Object.values(trackers)">
        <template v-slot:cell(name)="data">
          <span class="trackerName">{{ data.item.name }}</span><br><small style="opacity: .7">{{ data.item.imei }}</small>
        </template>
        <template v-slot:cell(owner)="data">
          <pre>{{ data.item.owner }}</pre>
        </template>
        <template v-slot:cell(status)="data">
          <p v-if="!data.item.insurerGranted" class="badge bg-danger text-white">{{ $t('insuredTrackers.NotGranted') }}</p>
          <div v-else>
            <p class="badge badge-dark">{{ $t('insuredTrackers.UntilColon') }} <TnLocalTime :time="data.item.insurerGrantUntil" format="l LT" /></p><br>
            <b-button-group>
              <TrackerStatus list :imei="data.item.imei" />
            </b-button-group>
          </div>
        </template>
        <template v-slot:cell(actions)="data">
          <b-button-group>
            <McButton
              :icon="['fad', 'location']"
              variant="success"
              :to="'/map/' + data.item.imei"
              :title="$t('trackers.ViewOnMap')"
              size="sm"
              v-if="TrackerStatusStore[data.item.imei] && $perms.hasPermission(data.item.imei, 'currentPosition')"
            />
            <McButton
              :icon="['fas', 'route']"
              :variant="data.item.modeData.mode == 'recovery' ? 'primary' : 'outline-primary'"
              @click="editTrackerMode(data.item)"
              :title="$t('trackers.RecoveryMode')"
              size="sm"
              v-if="$perms.hasPermission(data.item.imei, 'insurerPerms') && data.item.modeData && data.item.modeData.availableModes && data.item.modeData.availableModes.length > 1"
            />
          </b-button-group>
        </template>
      </McTable>
      <!--pre>{{ trackers }}</pre-->
    </div>
    <b-modal ref="recoverytrackerform" id="recoverytrackerform" :title="$t('trackers.RecoveryMode')" ok-only>
      <recoveryMode :imei="curTracker.imei" :noTitle="true" />
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { FormatPhone } from '../helpers/Formatting'
import { FormatError } from '../helpers/ErrorFormatting'
import TrackerService from '../services/TrackerService'

export default {
  data() {
    return {
      loadingState: true,
      activeState: false,
      activeMarking: -1,
      trackers: null,
      curTracker: {
        name: '',
        imei: '',
      },
    }
  },
  mounted() {
    this.getTrackers()
  },
  computed: {
    ...mapState({
      TrackerStatusStore: state => state.TrackerStatusStore.trackers,
    }),
    fields() {
      return [
        { key: 'name', priority: 0, mw: 200, sortable: true, label: this.$t('insuredTrackers.TrackerName') }, //
        { key: 'owner', priority: 3, mw: 120, sortable: false, label: this.$t('insuredTrackers.Owner') },
        { key: 'status', priority: 0, mw: 250, sortable: true, label: this.$t('insuredTrackers.Status'), class: 'text-center', sortByFormatted: (value, key, item) => item.insurerGranted ? '1' + item.insurerGrantUntil : '0' },
        { key: 'actions', priority: 0, mw: 200, label: this.$t('insuredTrackers.GoToMap'), class: 'text-right' },
      ]
    },
  },
  methods: {
    FormatPhone(phone) {
      return FormatPhone(phone)
    },
    editTrackerMode(item) {
      //console.log(item)
      this.curTracker = item
      this.$bvModal.show('recoverytrackerform')
    },
    getTrackers() {
      return TrackerService.listInsuredTrackers()
        .then(data => {
          this.trackers = data
          this.loadingState = false
        })
        .catch(error => {
          this.loadingState = FormatError(error)
        })
    },
  },
}
</script>
